/**
 * Routes out of the site. Every [data-awdd-outbound] trigger raises the outbound
 * dialog with its own data-what. A trigger with an href is a real
 * link (so it works without JS); one without is a button that is hidden until
 * this runs. The text is set with textContent; no copy lives here.
 */

import { openDialog } from './dialog.js';

/** The host without a leading www; the raw href if it cannot be parsed. */
const domainOf = (href) => {
	try {
		const host = new URL(href, window.location.href).hostname.replace(/^www\./, '');
		return host || href;
	} catch (err) {
		return href;
	}
};

export default function initOutbound() {
	const wrap = document.getElementById('awdd-dialog-outbound');
	if (!wrap) return;

	const what = wrap.querySelector('[data-awdd-outbound-what]');
	const link = wrap.querySelector('[data-awdd-outbound-link]');
	const linkText = wrap.querySelector('[data-awdd-outbound-link-text]');
	const closeBtn = wrap.querySelector('[data-awdd-dialog-close]');
	if (!what || !link || !linkText) return;

	document.querySelectorAll('button[data-awdd-outbound]').forEach((btn) => { btn.hidden = false; });

	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('[data-awdd-outbound]');
		if (!trigger) return;
		const href = trigger.getAttribute('href');
		// Let a link open normally on ctrl/meta/shift/alt or a non-primary button.
		if (href && (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)) return;
		e.preventDefault();

		what.textContent = trigger.dataset.what || '';
		if (href) {
			link.href = href;
			linkText.textContent = domainOf(href);
			link.hidden = false;
		} else {
			link.hidden = true;
		}
		// The dialog returns focus to the active element at open time, which is the
		// clicked trigger; focus it first so browsers that skip button focus agree.
		trigger.focus();
		openDialog('outbound');
	});

	// The domain link is the real navigation; close the dialog behind it.
	if (closeBtn) link.addEventListener('click', () => closeBtn.click());
}
